export const LIVING_WITH_CANCER_ID = 1;

// L&G CI referrals are always the carers pathway (member is a parent/carer of a
// child with cancer), so their join reason is always "Carer".
export const CARER_JOIN_REASON_ID = 2;

export const DIAGNOSED_CANCER_ACTIVE_TREATMENT_ID = 3;
export const DIAGNOSED_CANCER_COMPLETED_TREATMENT_ID = 4;
export const ABNORMAL_SCREENING_ID = 5;

const livingWithCancer = {
  id: LIVING_WITH_CANCER_ID,
  value: 'Living with cancer',
};
const carer = { id: CARER_JOIN_REASON_ID, value: 'Carer' };

// The unified join reason list (PRM-136, revised 14 Aug 2026): numeric ids
// are the stable API contract, labels may change freely. Ids 1-2 are
// historical, 3-5 are new; "6: Carer Of Cancer Patient" was dropped as a
// duplicate of 2.
export const allJoinReasons = [
  livingWithCancer,
  carer,
  {
    id: DIAGNOSED_CANCER_ACTIVE_TREATMENT_ID,
    value: 'Diagnosed Cancer Active Treatment',
  },
  {
    id: DIAGNOSED_CANCER_COMPLETED_TREATMENT_ID,
    value: 'Diagnosed Cancer Completed Treatment / Recovery',
  },
  { id: ABNORMAL_SCREENING_ID, value: 'Abnormal Screening' },
];

// Referral APIs accept every id above for any organization
export const allJoinReasonIds = allJoinReasons.map((reason) => reason.id);

export function displayJoinReason(joinReasonId: number): string {
  const reason = allJoinReasons.find((r) => r.id === joinReasonId);
  if (!reason) {
    throw new Error(`Unknown join reason id: ${joinReasonId}`);
  }
  return reason.value;
}
